var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 20.827,
    rx: 21,
    ry: 20.218,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 14.114c0-.407.336-.737.75-.737h10.5c.414 0 .75.33.75.737a.743.743 0 0 1-.75.736H23v13.505a.743.743 0 0 1-.75.737h-1.5a.743.743 0 0 1-.75-.737V25.9a.743.743 0 0 0-.75-.737h-2.5c-.414 0-.75.33-.75.737v2.455a.743.743 0 0 1-.75.737h-2.5a.743.743 0 0 1-.75-.737c0-.407.336-.737.75-.737H13V14.85h-.25a.743.743 0 0 1-.75-.736zm3 2.7c0-.27.224-.49.5-.49h1c.276 0 .5.22.5.49v.983a.496.496 0 0 1-.5.49h-1c-.276 0-.5-.22-.5-.49v-.983zm.5 3.438c-.276 0-.5.22-.5.491v.982c0 .272.224.491.5.491h1c.276 0 .5-.22.5-.49v-.983a.496.496 0 0 0-.5-.49h-1zm3.5-3.438c0-.27.224-.49.5-.49h1c.276 0 .5.22.5.49v.983a.496.496 0 0 1-.5.49h-1c-.276 0-.5-.22-.5-.49v-.983zm.5 3.438c-.276 0-.5.22-.5.491v.982c0 .272.224.491.5.491h1c.276 0 .5-.22.5-.49v-.983a.496.496 0 0 0-.5-.49h-1zM25.25 17.306c-.414 0-.75.33-.75.736V28.11c0 .543.448.983 1 .983h3.75c.414 0 .75-.33.75-.737a.743.743 0 0 0-.75-.737H29v-8.84h.25c.414 0 .75-.329.75-.736a.743.743 0 0 0-.75-.736h-4zm.5 3.437c0-.271.224-.49.5-.49h1c.276 0 .5.219.5.49v.982a.496.496 0 0 1-.5.491h-1c-.276 0-.5-.22-.5-.49v-.983zm.5 3.438c-.276 0-.5.22-.5.49v.983c0 .271.224.491.5.491h1c.276 0 .5-.22.5-.491v-.982a.496.496 0 0 0-.5-.491h-1z",
    fill: "#B54708"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplace);
export default __webpack_public_path__ + "static/media/workplace.4cb37a3ffb61e90cb4485082d0ebdfb6.svg";
export { ForwardRef as ReactComponent };